export type WcpStylesLikeForTooltipSurface = {
  color: {
    fg: {
      inverseException: string;
    };
  };
};

/**
 * Tooltip poppers use Canvas Kit inverse (dark) surfaces regardless of app theme.
 * `fg.inverseException` is hardcoded to #ffffff in both light and dark mode,
 * unlike `text.inverse` which flips to near-black (#0f141a) in dark mode.
 */
export function getTooltipSurfaceBodyTextColor(styles: WcpStylesLikeForTooltipSurface): string {
  return styles.color.fg.inverseException;
}
